var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:youtube-icon",
    clipPath: "url(#clip0_1418_373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.3829 3.74333C33.1871 3.01981 32.8052 2.36019 32.2752 1.83017C31.7452 1.30015 31.0856 0.918215 30.3621 0.7224C27.7133 0 17.0528 0 17.0528 0C17.0528 0 6.39171 0.0218666 3.74291 0.744267C3.01938 0.940093 2.35977 1.32205 1.82977 1.85209C1.29977 2.38214 0.917873 3.04178 0.72211 3.76533C-0.0790897 8.47173 -0.38989 15.6432 0.74411 20.1613C0.939893 20.8849 1.3218 21.5445 1.8518 22.0745C2.38179 22.6045 3.04139 22.9865 3.76491 23.1823C6.41371 23.9047 17.0745 23.9047 17.0745 23.9047C17.0745 23.9047 27.7352 23.9047 30.3838 23.1823C31.1074 22.9865 31.767 22.6045 32.297 22.0745C32.8271 21.5445 33.209 20.8849 33.4048 20.1613C34.2498 15.4483 34.5102 8.2812 33.3829 3.74333Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.6597 17.0746L22.5034 11.9522L13.6597 6.82983V17.0746Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1418_373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.14,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.1de59d6b5cb620488e05e0684112b8b8.svg";
export { ForwardRef as ReactComponent };